/* eslint react/prop-types: 0 */

import 'src/styles/app.sass'
import React from 'react'
import store, { dispatch, getState } from 'src/store'
import { Provider } from 'react-redux'
import { onResize, setShouldScroll, subscribeToResize, loadForm, sendPageView } from 'src/actions'

export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>
}

export const onInitialClientRender = () => {
  dispatch(onResize())
  dispatch(subscribeToResize())
  dispatch(loadForm())
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  dispatch(sendPageView(location, prevLocation))
}

export const shouldUpdateScroll = () => {
  const { shouldScroll } = getState()
  dispatch(setShouldScroll(false))
  return !shouldScroll
}
